export default "__VITE_ASSET__d7e1b80b__"